export default "__VITE_ASSET__urk0PxAY__"